"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetComponentsListByType = exports.useGetComponentsIdByTypeWithLink = exports.useGetComponentsIdByType = exports.useGetComponentsByType = exports.useGetComponentByTypeAndId = exports.useGetComponentById = void 0;
require("core-js/modules/es.array.reduce.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _selectors = require("../../redux/selectors");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const useGetComponentsByType = _ref => {
  let {
    type = ''
  } = _ref;
  return ((0, _reactRedux.useSelector)(_selectors.getComponents) || {})[type] || {};
};
exports.useGetComponentsByType = useGetComponentsByType;
const useGetComponentsListByType = _ref2 => {
  let {
    type = ''
  } = _ref2;
  return Object.values(useGetComponentsByType({
    type
  }));
};
exports.useGetComponentsListByType = useGetComponentsListByType;
const useGetComponentsIdByType = _ref3 => {
  let {
    type = ''
  } = _ref3;
  return Object.keys(useGetComponentsByType({
    type
  }));
};
exports.useGetComponentsIdByType = useGetComponentsIdByType;
const useGetComponentByTypeAndId = _ref4 => {
  let {
    type = '',
    id = null
  } = _ref4;
  return (useGetComponentsByType({
    type
  }) || {})[id] || null;
};
exports.useGetComponentByTypeAndId = useGetComponentByTypeAndId;
const useGetComponentById = _ref5 => {
  let {
    id = null
  } = _ref5;
  const components = (0, _reactRedux.useSelector)(_selectors.getComponents) || {};
  return Object.values(components).reduce((acc, group) => group[id] || acc, null);
};
exports.useGetComponentById = useGetComponentById;
const useGetComponentsIdByTypeWithLink = _ref6 => {
  let {
    type = '',
    hasLinks = ''
  } = _ref6;
  return Object.values(useGetComponentsByType({
    type
  }) || {}).reduce((acc, c) => {
    var _c$hasLinks;
    return (_c$hasLinks = c[hasLinks]) !== null && _c$hasLinks !== void 0 && _c$hasLinks.length ? [...acc, c.id] : acc;
  }, []);
};
exports.useGetComponentsIdByTypeWithLink = useGetComponentsIdByTypeWithLink;